import ErrorIcon from "@mui/icons-material/Error";
import { Box, Link, Paper, Typography } from "@mui/material";
import { useEffect, useState } from "react";

export default function NotFound() {
    const currentUrl = window.location.href;
    const redirectUrl = currentUrl.replace(/\/NotFound(\/|$)/, "$1");

    const [countdown, setCountdown] = useState(10);

    useEffect(() => {
        if (countdown <= 0) {
            window.location.href = redirectUrl;
            return;
        }

        const interval = setInterval(() => {
            setCountdown((prev) => prev - 1);
        }, 1000);

        return () => clearInterval(interval);
    }, [countdown, redirectUrl]);

    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "100vh",
                padding: 2,
                backgroundColor: "#f5f5f5",
            }}
        >
            <Paper
                sx={{
                    maxWidth: 650,
                    width: "100%",
                    padding: 4,
                    textAlign: "center",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 1,
                    }}
                >
                    <ErrorIcon color="error" sx={{ fontSize: 60 }} />
                    <Typography variant="h5">Page Not Found</Typography>
                </Box>

                {/* 英文版 */}
                <Typography variant="body1" sx={{ mt: 3, mb: 3 }}>
                    Sorry, the page you requested cannot be found.
                    <br />
                    You will be redirected to the Education Bureau’s Electronic
                    Form Submission System of in {countdown} second
                    {countdown !== 1 ? "s" : ""}.
                    <br />
                    You can also click this link to access the Education
                    Bureau’s Electronic Form Submission System.
                    <br />
                    <Link href={redirectUrl}>{redirectUrl}</Link>
                </Typography>

                {/* 繁體版 */}
                <Typography variant="body1" sx={{ mt: 3, mb: 3 }}>
                    抱歉，我們找不到你要求的網頁。
                    <br />
                    你將於 {countdown} 秒內跳轉到教育局電子表格遞交系統。
                    <br />
                    你亦可點撃此連結，進入教育局電子表格遞交系統。
                    <br />
                    <Link href={redirectUrl}>{redirectUrl}</Link>
                </Typography>

                {/* 簡體版 */}
                <Typography variant="body1" sx={{ mt: 3 }}>
                    抱歉，我们找不到你要求的网页。
                    <br />
                    你将于 {countdown} 秒内跳转到教育局电子表格递交系统。
                    <br />
                    你亦可点击此连结，进入教育局电子表格递交系统。
                    <br />
                    <Link href={redirectUrl}>{redirectUrl}</Link>
                </Typography>
            </Paper>
        </Box>
    );
}
